// src/features/organisation/hooks/usePositions.ts
import { useState, useEffect } from 'react';
import { Position, PositionCreateDto } from '../../../types/organisation';
import { apiClient } from '../../../services/api/client';

export const usePositions = () => {
  const [positions, setPositions] = useState<Position[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchPositions = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await apiClient.get<Position[]>('/organisation/positions');
      setPositions(data);
    } catch (err) {
      setError(err as Error);
      console.error('Erreur lors du chargement des postes:', err);
      // En cas d'erreur, pas de données mockées
      setPositions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPositions();
  }, []);

  return {
    positions,
    loading,
    error,
    refresh: fetchPositions
  };
};

export const usePositionActions = () => {
  const createPosition = async (positionData: PositionCreateDto): Promise<Position> => {
    try {
      return await apiClient.post<Position>('/organisation/positions', positionData);
    } catch (error) {
      console.error('Erreur lors de la création du poste:', error);
      throw error;
    }
  };

  const updatePosition = async (id: number, positionData: PositionCreateDto): Promise<Position> => {
    try {
      return await apiClient.put<Position>(`/organisation/positions/${id}`, positionData);
    } catch (error) {
      console.error('Erreur lors de la modification du poste:', error);
      throw error;
    }
  };

  const deletePosition = async (id: number): Promise<void> => {
    try {
      await apiClient.delete(`/organisation/positions/${id}`);
    } catch (error) {
      console.error('Erreur lors de la suppression du poste:', error);
      throw error;
    }
  };

  return {
    createPosition,
    updatePosition,
    deletePosition
  };
};
